/* global fetch */
import { get, isFunction } from 'lodash';
import { clearLocalStorage, getSessionUrls } from './paypal-utils';
import { ORIGINS } from './paypal-constants';
import request from './request';

const approveOrder = (callback) => {
	return (data, actions) => {
		const sessionUrls = getSessionUrls();
		const baseUrl = get(sessionUrls, 'returnUrl');
		//sb=1 indicates that this is originating from the paypal Smart Button Experience as opposed to the legacy EC experience
		const url = `${baseUrl}/${ORIGINS.paypal.checkout}?token=${data.orderID}&sb=1`;
		
		//This call back can be used to show a loading spinner
		if (isFunction(callback)) {
			callback(true);
		}
		
		return request(url)
			.then((response) => {
				if (response.restart) {
					return actions.restart();
				} else if (response.error) {
					return actions.redirect('?code=6004');
				}
				//once the order is approved remove paypal local storage keys
				clearLocalStorage();
	
				if(response.redirected && response.url) {
					return actions.redirect(response.url);
				}
			});
	};
};

module.exports = approveOrder;
